import {
  IPersistenceTrackingClient,
  PersistenceTrackingData,
} from '../../../../store/middleware/tracking/clients/trackingClient';

type SuccessInitializationTrackingResult = {
  isSuccess: true;
  trackingClient: IPersistenceTrackingClient;
  persistedTrackingData: PersistenceTrackingData;
};

type FailedInitializationTrackingResult = {
  isSuccess: false;
  reason: 'init failed' | 'get data failed';
  error: Error | null;
};

export const safeInitializationOfTrackingClient = async (trackingClient: IPersistenceTrackingClient): Promise<SuccessInitializationTrackingResult | FailedInitializationTrackingResult>  => {
  try {
    const initialized = await trackingClient.init();
    if (!initialized) {
      return { isSuccess: false, reason: 'init failed', error: null };
    }
  } catch (error) {
    return { isSuccess: false, reason: 'init failed', error: error as Error };
  }

  try {
    const persistedTrackingData: PersistenceTrackingData = await trackingClient.getTrackingData();
    return { isSuccess: true, trackingClient, persistedTrackingData };
  } catch (error) {
    return { isSuccess: false, reason: 'get data failed', error: error as Error };
  }
}


